// Перекодировка записи микрофона в WAV (моно, 16 кГц, 16-бит PCM) в браузере.
// Распознавалка (Gemini) принимает wav/mp3/ogg/flac/aac, НО НЕ webm (Chrome) и НЕ
// mp4 (Safari) — то, что отдаёт MediaRecorder. Общий хелпер: Generator + Composer.
export async function blobToWavBase64(blob: Blob): Promise<string> {
  const AC: typeof AudioContext =
    window.AudioContext ??
    (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
  const ctx = new AC();
  const decoded = await ctx.decodeAudioData(await blob.arrayBuffer());
  void ctx.close().catch(() => {});

  // Сводим в моно.
  const srcLen = decoded.length;
  const channels = decoded.numberOfChannels;
  const mono = new Float32Array(srcLen);
  for (let c = 0; c < channels; c++) {
    const d = decoded.getChannelData(c);
    for (let i = 0; i < srcLen; i++) mono[i] = (mono[i] ?? 0) + (d[i] ?? 0) / channels;
  }

  // Ресемпл (линейный) к 16 кГц — компактно и достаточно для речи.
  const targetRate = 16000;
  const ratio = decoded.sampleRate / targetRate;
  const outLen = Math.max(1, Math.floor(srcLen / ratio));
  const out = new Float32Array(outLen);
  for (let i = 0; i < outLen; i++) {
    const idx = i * ratio;
    const i0 = Math.floor(idx);
    const i1 = Math.min(i0 + 1, srcLen - 1);
    const frac = idx - i0;
    out[i] = (mono[i0] ?? 0) * (1 - frac) + (mono[i1] ?? 0) * frac;
  }

  // Кодируем WAV (16-бит PCM, моно).
  const buf = new ArrayBuffer(44 + outLen * 2);
  const view = new DataView(buf);
  const ascii = (off: number, s: string) => {
    for (let i = 0; i < s.length; i++) view.setUint8(off + i, s.charCodeAt(i));
  };
  ascii(0, 'RIFF');
  view.setUint32(4, 36 + outLen * 2, true);
  ascii(8, 'WAVE');
  ascii(12, 'fmt ');
  view.setUint32(16, 16, true);
  view.setUint16(20, 1, true); // PCM
  view.setUint16(22, 1, true); // моно
  view.setUint32(24, targetRate, true);
  view.setUint32(28, targetRate * 2, true);
  view.setUint16(32, 2, true);
  view.setUint16(34, 16, true);
  ascii(36, 'data');
  view.setUint32(40, outLen * 2, true);
  let off = 44;
  for (let i = 0; i < outLen; i++) {
    const s = Math.max(-1, Math.min(1, out[i] ?? 0));
    view.setInt16(off, s < 0 ? s * 0x8000 : s * 0x7fff, true);
    off += 2;
  }

  // base64
  const bytes = new Uint8Array(buf);
  let bin = '';
  const CHUNK = 0x8000;
  for (let i = 0; i < bytes.length; i += CHUNK) {
    bin += String.fromCharCode(...bytes.subarray(i, i + CHUNK));
  }
  return btoa(bin);
}
